module.exports = __webpack_public_path__ + "media/images/OPL 99-03b6aa493ce92f923bcfc181d5f1aca6.png";